import { t } from './i18n.es.js';

const ORDER_TAB_WAIT_PAYMENT = 0;
const ORDER_TAB_WAIT_CONFIRM = 1;
const ORDER_TAB_WAIT_DELIVER = 1;
const ORDER_TAB_PROCESSING = 1;
const ORDER_TAB_DELIVERED = 2;
const ORDER_TAB_CANCELED = 2;
const ORDER_TAB_DONE = 2;
const ORDER_STATE_DELIVERED = "DELIVERED";
const ORDER_CUSTOMER_STATE_WAITING_DELIVERY = 1;
const ORDER_CUSTOMER_STATE_DELIVERING = 2;
const STAFF_ORDER_STATUS_CREATED = "CREATED";
const STAFF_ORDER_STATUS_PAYMENT_CONFIRMED = "PAYMENT_CONFIRMED";
const STAFF_ORDER_STATUS_CANCELLED_DRAFT = "CANCELLED_DRAFT";
const STAFF_ORDER_STATUS_DELIVERED = "DELIVERED";
const STAFF_ORDER_STATUS_DELIVERING = "DELIVERING";
const STAFF_ORDER_STATUS_WAIT_FOR_PROCESS = "WAIT_FOR_PROCESS";
const STAFF_ORDER_STATUS_PROCESSING = "PROCESSING";
const STAFF_ORDER_STATUS_NEED_REFUND = "NEED-REFUND";
const STAFF_ORDER_STATES = {
  new: t("\u0110\u01A1n m\u1EDBi t\u1EA1o"),
  active: t("Ch\u1EDD thanh to\xE1n"),
  paid: t("\u0110\xE3 thanh to\xE1n"),
  processing: t("\u0110ang x\u1EED l\xFD"),
  cancelled: t("\u0110\xE3 h\u1EE7y"),
  delivered: t("\u0110\xE3 giao h\xE0ng"),
  returned: t("\u0110\xE3 tr\u1EA3 h\xE0ng"),
  reverted: t("\u0110\xE3 tr\u1EA3 h\xE0ng"),
  refund: t("\u0110\xE3 ho\xE0n ti\u1EC1n")
};
const STATUS_COLOR = {
  waiting: "",
  processing: "#f78212",
  success: "#53c305",
  canceled: "#d60f29"
};
const CONSUMER_ORDER_STATUSES = [
  {
    status: "DRAFT",
    text: null,
    displayStatus: null,
    tab: null,
    color: ""
  },
  {
    status: "WAITING_FOR_APPROVAL",
    text: "Ch\u1EDD duy\u1EC7t",
    displayStatus: "Ch\u1EDD duy\u1EC7t",
    tab: null,
    color: ""
  },
  {
    status: "CREATED",
    text: null,
    displayStatus: null,
    tab: null,
    color: ""
  },
  {
    status: "PENDING",
    text: "Ch\u1EDD x\xE1c nh\u1EADn",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    tab: ORDER_TAB_WAIT_PAYMENT,
    color: STATUS_COLOR.processing
  },
  {
    status: "PROCESSING",
    text: "\u0110ang x\u1EED l\xFD",
    displayStatus: "\u0110ang x\u1EED l\xFD",
    tab: ORDER_TAB_PROCESSING,
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_PAYMENT_CONFIRMATION",
    text: "Ch\u1EDD thanh to\xE1n",
    displayStatus: "Ch\u1EDD thanh to\xE1n",
    tab: ORDER_TAB_WAIT_PAYMENT,
    color: STATUS_COLOR.processing
  },
  {
    status: "PAYMENT_CONFIRMED",
    text: "\u0110\xE3 thanh to\xE1n",
    displayStatus: "\u0110\xE3 thanh to\xE1n",
    tab: ORDER_TAB_PROCESSING,
    color: STATUS_COLOR.processing
  },
  {
    status: "CANCELLED",
    text: "\u0110\xE3 h\u1EE7y",
    displayStatus: "\u0110\xE3 h\u1EE7y",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "REVERTED",
    text: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "RETURNED",
    text: "Tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "REFUND",
    text: "Tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "NEED_REFUND",
    text: "Tr\u1EA3 h\xE0ng",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.canceled
  },
  {
    status: "DELIVERING",
    text: "\u0110ang giao h\xE0ng",
    displayStatus: "\u0110ang giao h\xE0ng",
    tab: ORDER_TAB_PROCESSING,
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERED",
    text: "Ho\xE0n th\xE0nh",
    displayStatus: "Ho\xE0n th\xE0nh",
    tab: ORDER_TAB_DONE,
    color: STATUS_COLOR.success
  }
];
const ORDER_SHIPMENT_STATUS = [
  {
    status: "NEW",
    displayStatus: "M\u1EDBi",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_MANUAL_CONFIRMATION",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "PROVIDER_TRANSFERRING",
    displayStatus: "\u0110\xE3 ti\u1EBFp nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "PROVIDER_TRANSFERRED",
    displayStatus: "\u0110\xE3 ti\u1EBFp nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAIT_FOR_PRODUCT",
    displayStatus: "Ch\u1EDD l\u1EA5y h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_PRODUCT",
    displayStatus: "Ch\u1EDD giao h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "PICKING",
    displayStatus: "\u0110ang l\u1EA5y h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "PICKED",
    displayStatus: "\u0110\xE3 l\u1EA5y h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "PACKED",
    displayStatus: "\u0110\xF3ng g\xF3i xong",
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERING",
    displayStatus: "\u0110ang giao",
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERED",
    displayStatus: "\u0110\xE3 giao",
    color: STATUS_COLOR.success
  },
  {
    status: "PARTIAL_DELIVERED",
    displayStatus: "Giao m\u1ED9t ph\u1EA7n",
    color: STATUS_COLOR.processing
  },
  {
    status: "RETURNED",
    displayStatus: "\u0110\xE3 tr\u1EA3 h\xE0ng",
    color: STATUS_COLOR.success
  },
  {
    status: "PARTIAL_CANCELLED",
    displayStatus: "\u0110\xE3 h\u1EE7y",
    color: STATUS_COLOR.success
  },
  {
    status: "CANCELLED",
    displayStatus: "\u0110\xE3 h\u1EE7y",
    color: STATUS_COLOR.canceled
  },
  {
    status: "PROCESSING",
    displayStatus: "Ch\u1EDD giao h\xE0ng",
    color: STATUS_COLOR.processing
  },
  {
    status: "DELIVERED_AT_AGENCY",
    displayStatus: "\u0110\xE3 giao \u0111\u1EA1i l\xFD",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_WAREHOUSE_CONFIRMATION",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "WAITING_FOR_BACKORDER_CONFIRMATION",
    displayStatus: "Ch\u1EDD x\xE1c nh\u1EADn",
    color: STATUS_COLOR.processing
  },
  {
    status: "BACKORDERING",
    displayStatus: "Ch\u1EDD h\xE0ng v\u1EC1",
    color: STATUS_COLOR.processing
  },
  {
    status: "BACKORDER_INSUFFICIENT_STOCK",
    displayStatus: "Ch\u1EDD h\xE0ng v\u1EC1",
    color: STATUS_COLOR.processing
  }
];
const orderStatus = {
  WAITING_FOR_MANUAL_CONFIRMATION: "WAITING_FOR_MANUAL_CONFIRMATION",
  WAIT_FOR_PROCESS: "WAIT_FOR_PROCESS",
  PROCESSING: "PROCESSING",
  DELIVERED: "DELIVERED",
  PAYMENT_CONFIRMED: "PAYMENT_CONFIRMED",
  PAID: "PAID",
  PENDING: "PENDING",
  WAITING_FOR_PAYMENT_CONFIRMATION: "WAITING_FOR_PAYMENT_CONFIRMATION",
  CANCELLED: "CANCELLED",
  REVERTED: "REVERTED",
  RETURNED: "RETURNED",
  CONFIRMED: "CONFIRMED",
  WAITING_FOR_PICKING: "WAITING_FOR_PICKING",
  PACKED: "PACKED",
  DELIVERING: "DELIVERING",
  READY_FOR_PICKUP: "READY_FOR_PICKUP",
  REFUND: "REFUND"
};

export { CONSUMER_ORDER_STATUSES, ORDER_CUSTOMER_STATE_DELIVERING, ORDER_CUSTOMER_STATE_WAITING_DELIVERY, ORDER_SHIPMENT_STATUS, ORDER_STATE_DELIVERED, ORDER_TAB_CANCELED, ORDER_TAB_DELIVERED, ORDER_TAB_DONE, ORDER_TAB_PROCESSING, ORDER_TAB_WAIT_CONFIRM, ORDER_TAB_WAIT_DELIVER, ORDER_TAB_WAIT_PAYMENT, STAFF_ORDER_STATES, STAFF_ORDER_STATUS_CANCELLED_DRAFT, STAFF_ORDER_STATUS_CREATED, STAFF_ORDER_STATUS_DELIVERED, STAFF_ORDER_STATUS_DELIVERING, STAFF_ORDER_STATUS_NEED_REFUND, STAFF_ORDER_STATUS_PAYMENT_CONFIRMED, STAFF_ORDER_STATUS_PROCESSING, STAFF_ORDER_STATUS_WAIT_FOR_PROCESS, STATUS_COLOR, orderStatus };
